import appWindow from "@shared/utils/app-window.ts";

export const isRunningOnTour = () => {
  const operationModeIsTour = appWindow.OPERATION_MODE === "tour";

  const urlIsAllowedForTour =
    window.location.host.startsWith("localhost") ||
    window.location.host.startsWith("demo-");

  return operationModeIsTour && urlIsAllowedForTour;
};
